// extracted by mini-css-extract-plugin
module.exports = {"page__background":"works-module--page__background--2Y-1B","page__backgroundBall":"works-module--page__background-ball--2GSkT"};